:root ._dsp-flex{display:flex;}
:root ._items-stretch{align-items:stretch;}
:root ._fd-column{flex-direction:column;}
:root ._fb-auto{flex-basis:auto;}
:root ._bxs-border-box{box-sizing:border-box;}
:root ._minH-0px{min-height:0px;}
:root ._minW-0px{min-width:0px;}
:root ._shrink-0{flex-shrink:0;}
:root ._pos-absolute{position:absolute;}
:root ._b-0px{bottom:0px;}
:root ._height-96px{height:96px;}
:root ._r-0px{right:0px;}
:root ._l-0px{left:0px;}
:root ._z-15{z-index:15;}
:root ._cur-pointer{cursor:pointer;}